import { createFileRoute } from "@tanstack/react-router";
import Article from "@/pages/Article";
import { buildArticleHead } from "@/data/seo";

export const Route = createFileRoute("/nyheter/$slug")({
  head: ({ params }) => buildArticleHead(params.slug, "nyheter"),
  component: () => <Article category="nyheter" />,
});
